import { render, staticRenderFns } from "./MasterPaymentMethodDialog.vue?vue&type=template&id=70d1c53a&scoped=true&"
import script from "./MasterPaymentMethodDialog.vue?vue&type=script&lang=js&"
export * from "./MasterPaymentMethodDialog.vue?vue&type=script&lang=js&"
import style0 from "./MasterPaymentMethodDialog.vue?vue&type=style&index=0&id=70d1c53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d1c53a",
  null
  
)

export default component.exports